import { Route } from "react-router-dom";

import { AgentsTabs } from "./AgentsTabs";
import { AgentSessionDetail } from "./Sessions/AgentSessionDetail";

/**
 * Route tree for the top-level Agents section.
 *
 * Centralized here (rather than declared inline in `Router.tsx`) so all
 * `/agents/*` routes live in one place — matches the convention used by
 * `ActionsRoutes`, `DatasetsRoutes`, etc. Future agent-editor / invoke /
 * agent-detail routes slot in here as siblings.
 *
 * `AgentsTabs` is the index landing; deep links into a specific tab use
 * `?tab=N` so a refresh preserves the user's selection.
 */
export const AgentsRoutes = () => [
  <Route key={"index"} index element={<AgentsTabs />} />,
  <Route
    key={"session-detail"}
    path="sessions/:sessionId"
    element={<AgentSessionDetail />}
  />,
];
